export default "__VITE_ASSET__f557f2cd__"